import * as state from './state';

const actions = { ...state.socketActions };

export {
  state,
  actions,
};
